<template>
  <div class="col-12 row form-group">
    <div class="col-6">
      <label class="my-0 mt-2" for="input-live">First Name</label>
      <input
        class="form-control"
        id="first_name"
        type="text"
        v-model="first_name"
      />
    </div>
    <div class="col-6">
      <label class="my-0 mt-2" for="input-live">Last Name</label>
      <input
        class="form-control"
        id="last_name"
        type="text"
        v-model="last_name"
      />
    </div>
    <div class="col-6">
      <label class="my-0 mt-2" for="input-live">Phone</label>
      <input class="form-control" id="phone" type="text" v-model="phone" />
    </div>
    <div class="col-6">
      <label class="my-0 mt-2" for="input-live">E-mail</label>
      <input class="form-control" id="email" type="text" v-model="email" />
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {
      filterTab: Number,
    },
    data() {
      return {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
      };
    },

    watch: {
      // whenever question changes, this function will run
      filterTab(newValue, oldValue) {
        // let myFilter = JSON.parse(localStorage.getItem('filter-report-case'));
        // if (newValue == 1) {
        // this.dateStart = myFilter.dateStart;
        // this.dateEnd = myFilter.dateEnd;
        // } else {
        // this.dateStart = '';
        // this.dateEnd = '';
        // }
      },
    },
    mounted() {},
    methods: {
      getFilter() {
        let object = {
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
          email: this.email,
        };
        return object;
      },
      inputHandler(eventData) {
        console.log(eventData);
      },
    },
  };
</script>

<style></style>
